// extracted by mini-css-extract-plugin
module.exports = {"tabs":"WorkspaceTabBar_tabs__iIA36"};